import React, { useEffect, useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { matchPath, useHistory, useLocation } from "react-router-dom";
import Grid from "@material-ui/core/Grid/Grid";
import Button from "@components/Button";
import Typography from "@components/Typography";
import CustomTooltip from "@components/CustomTooltip";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CheckIcon from "@material-ui/icons/Check";
import CustomContainer from "@components/Container";
import clsx from "clsx";
import { Link } from "react-router-dom";

const noFooterRoutes = [
  "/live/courses/:courseId/sessions/:sessionId",
  "/courses/:courseId/sessions/:sessionId/files/:fileId",
];
const options = ["فارسی", "English", "عربی"];
const logos = [
  {
    href: "#",
    src: "/static/icons/Social-footer/google_color.svg",
    name: "Google",
  },
  {
    href: "#",
    src: "/static/icons/Social-footer/twitter_color.svg",
    name: "Twitter",
  },
  {
    href: "#",
    src: "/static/icons/Social-footer/facebook_color.svg",
    name: "Facebook",
  },
  {
    href: "#",
    src: "/static/icons/Social-footer/instagram_color.svg",
    name: "Instagram",
  },
];
const Footer = (props) => {
  const { opanMenu, paddingLayout } = props;
  const classes = useStyles();
  const [visible, setVisible] = useState(null);
  const [language, setLanguage] = useState("فارسی");
  const [state, setState] = useState();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const noFooter = noFooterRoutes.find((path) =>
      matchPath(history.location.pathname, {
        path: path,
        exact: true,
      })
    );
    setVisible(noFooter ? false : true);
  }, [location]);
  const handleChange = (event) => {
    setLanguage(event.target.value);
  };
  const iconComponent = (props) => {
    return <ExpandMoreIcon className={props.className} />;
  };

  if (visible) {
    return (
      <div className={classes.root}>
        <CustomContainer
          maxWidth=""
          classes={clsx(classes.pageContentWrapper, {
            classOpanMenu: !!opanMenu,
            paddingLayout: !!paddingLayout,
          })}
        >
          <Grid container justify="space-between" alignItems="center">
            <Grid item {...{ xl: 5, lg: 5, md: 5, xs: 12, sm: 12 }}>
              <div className={classes.footerBrandRow}>
                <img
                  alt="footer"
                  className={classes.footerLogo}
                  height={20}
                  src="/static/icons/Logo/Logo-gray-footer.svg"
                />
                <Typography color="secondary.tint60" variant="xs">
                  {__t("© 2026 Fibitex Technologies Inc. All rights reserved")}
                </Typography>
              </div>
            </Grid>
            <Grid item {...{ xl: 4, lg: 4, md: 4, xs: 12, sm: 12 }}>
              {logos.map((item) => (
                <CustomTooltip title={item.name} placement="top">
                  <Link
                    variant="text"
                    size="small"
                    className={classes.button}
                    href={item.href}
                  >
                    <span className={classes.icon}>
                      <img src={item.src} alt={item.name} />
                    </span>
                  </Link>
                </CustomTooltip>
              ))}
            </Grid>
            <Grid
              item
              {...{ xl: 3, lg: 3, md: 3, xs: 12, sm: 12 }}
              justify="flex-end"
              className={classes.footerItem}
            >
              <Select
                className={classes.textField}
                IconComponent={iconComponent}
                value={language}
                onChange={handleChange}
                size="small"
                MenuProps={{
                  classes: {
                    paper: classes.dropdownStyle,
                    list: classes.menuList,
                  },
                }}
                inputProps={{ tabIndex: "-1" }}
              >
                {options.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        </CustomContainer>
      </div>
    );
  }
  return null;
};
export default Footer;
